<template>
  <div class="left_block all-users">
    <p class="header">Все пользователи</p>

    <UsersFilter
      @handle-change="loadData"
      :rows="rows"
      @restore="restoreChecked"
      :search="search"
      @delete-checked="deleteChecked"
      @open-modal="openUserCreateModal"
      @open-file-modal="openFileModal"
    />
    <b-modal @close="closeFileModal" :active.sync="loadFile" has-modal-card scroll="keep">
      <LoadFile @save="createUserFromFile" @close-modal="closeFileModal" />
    </b-modal>
    <UsersTable
      :is-loading="isLoading"
      :total-count="totalCount"
      @changePage="changePage"
      :rows="rows"
      :users-list="usersList"
      @delete-user="deleteUser"
      @restore="restoreUser"
      @init-sort="initSort"
    />

    <b-modal :active.sync="userCreateModal" has-modal-card scroll="keep">
      <CreateUsers
        @change="changeRole"
        @add-user="addUser"
        @remove-user="removeUser"
        :new-users="newUsers"
        :modal-info="modal"
        @create-user="createUser"
        @close-modal="closeUserCreateModal"
      />
    </b-modal>
  </div>
</template>

<script>
import UsersFilter from '@/components/admin/users/UsersFilter'
import UsersTable from '@/components/admin/users/UsersTable'
import CreateUsers from '@/components/admin/users/CreateUsers'
import LoadFile from '@/components/admin/users/LoadFile'
import { toastInfo } from '@/lib/toastCfg'

export default {
  components: {
    UsersFilter,
    UsersTable,
    CreateUsers,
    LoadFile
  },
  data() {
    return {
      userCreateModal: false,
      isLoading: true,
      loadFile: false,
      modal: {
        role: 2,
        rolename: 'Студент'
      },
      newUsers: [],
      rows: {
        checked: []
      },
      search: {
        name: '',
        role: 0,
        branch_id: 0,
        trashed: false,
        page: 1,
        sort: 'surname',
        sort_type: 'asc'
      }
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    totalCount() {
      return this.$store.state.allUsers.usersList.total
    },
    usersList() {
      return this.$store.state.allUsers.usersList.users
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.search.sort_type = sortType
      this.search.sort = fieldName
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const qs = require('qs')
      const params = {}
      Object.keys(this.search).forEach((el) => {
        if (this.search[el] && this.search[el] !== 0) {
          params[el] = this.search[el]
        }
      })
      this.$axios2
        .get('users?' + qs.stringify(params))
        .then((resp) => {
          this.isLoading = false
          this.$store.commit('setUsersList', { list: resp.data })
        })
        .catch((err) => {
          this.$errorToast(err)
          this.isLoading = false
        })
    },
    addUser() {
      this.newUsers.push({
        role: null,
        branch_id: null,
        name: '',
        surname: '',
        patronymic: '',
        position: '',
        id: '',
        email: ''
      })
    },
    removeUser(index) {
      this.newUsers.splice(index, 1)
    },
    changePage(pageNumber) {
      this.search.page = pageNumber
      this.loadData()
    },
    restoreUser(userID) {
      this.$axios2
        .patch('users/' + userID)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
        })
        .catch(this.$errorToast)
    },
    restoreChecked() {
      for (let i = 0; i < this.rows.checked.length; i++) {
        this.restoreUser(this.rows.checked[i].id)
      }
      this.rows.checked = []
    },
    deleteChecked() {
      for (let i = 0; i < this.rows.checked.length; i++) {
        this.deleteUser(this.rows.checked[i].id)
      }
      this.rows.checked = []
    },
    deleteUser(userId) {
      if (userId !== this.$store.state.auth.currentUser.id) {
        this.$axios2
          .delete('users/' + userId)
          .then(() => {
            this.$buefy.toast.open(toastInfo())
            this.loadData()
          })
          .catch(this.$errorToast)
      }
    },
    createUser() {
      this.newUsers.forEach((user) => {
        let newUser = {
          role: this.modal.role,
          name: user.name,
          surname: user.surname,
          patronymic: user.patronymic,
          position: user.position,
          branch_id: this.modal.role !== 1 && this.modal.role !== 3 ? user.branch_id : 1
        }
        if (user.email.length) {
          newUser['email'] = user.email
        }
        this.$axios2
          .post('users', newUser)
          .then(() => {
            this.$buefy.toast.open(toastInfo())
            this.closeUserCreateModal()
            this.loadData()
          })
          .catch(this.$errorToast)
      })
    },
    openUserCreateModal() {
      this.newUsers = []
      this.userCreateModal = true
      this.modal.creation = true
    },
    closeUserCreateModal() {
      this.userCreateModal = false
    },
    changeRole() {
      this.newUsers = []
    },
    createUserFromFile(file) {
      const fData = new FormData()
      fData.append('excel', file)
      this.$axios2
        .post('users/excel', fData, { headers:  { 'content-type': 'multipart/form-data' } })
        .then(() => {
          this.closeFileModal(),
          this.$buefy.toast.open({
            message: 'Пользователи добавлены',
            type: 'is-info',
            position: 'is-top-right',
            duration: 2000,
            queue: false
          })
        })
        .catch(this.$errorToast)
    },
    closeFileModal() {
      this.loadFile = false
    },
    openFileModal() {
      this.loadFile = true
    }

  }
}
</script>
